import { render, staticRenderFns } from "./EngravingItem.vue?vue&type=template&id=01659ce0&scoped=true"
import script from "./EngravingItem.vue?vue&type=script&lang=js"
export * from "./EngravingItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01659ce0",
  null
  
)

export default component.exports